export default "__VITE_ASSET__DcxidCRB__"